import React, { Component } from 'react';
import $ from 'jquery';
import LoadingPage from '../../../../loading-page/loading-page';
import {Tabs, Tab } from 'react-bootstrap';
import './content-left-description.css';
import './content-left-description-skelton.css';


class ContentLeftDescriptionSkelton extends Component {

    constructor(props) {
        super(props);
    }

    render() {

            return (
                <div className="row padding_20">
                    <div className="col-md-12 re_desctable re_desctable_style">

                        <Tabs defaultActiveKey={1} id="uncontrolled-tab-example">
                            <Tab eventKey={1} title="Description" className="tab-content_style">
                                <div class="demo "></div>
                            </Tab>
                            <Tab eventKey={2} title="Table of Contents" disabled>

                            </Tab>
                        </Tabs>

                    </div>
                </div>
            )}

}


export default ContentLeftDescriptionSkelton;


// WEBPACK FOOTER //
// ./src/report-description/content/content-left/content-left-description/content-left-description-skelton.js